import PropTypes from 'prop-types';
import React from 'react';
import styles from './CardHeader.css?module';
import CardCertification from 'components/CardCertification';

const CardHeader = ({card}) => (
  <div className={styles.cardHeader}>
    <div className={styles.title}>{card.title}</div>
    <div className={styles.certification}>
      <CardCertification card={card} />
    </div>
  </div>
);

CardHeader.propTypes = {
  card: PropTypes.object.isRequired,
};

export default CardHeader;
